'use client';
import React from 'react';
import TermsOfUse from '../../../components/organisms/termsOfUse';


const TermsOfUsePage = () => {
    return (
        <TermsOfUse />
    );
};

export default TermsOfUsePage;